<template>

        <iframe width="100%" height="100%"  :src="videoUrl" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

</template>

<script>
export default {
    props:{
        componentData:String
    },
    computed:{
        videoUrl(){
            let arrUrl = this.componentData.split('/')
            arrUrl = arrUrl[arrUrl.length-1].split('=')
           return 'https://www.youtube.com/embed/' + arrUrl[arrUrl.length-1]
        }
        
    }
}
</script>

<style>

</style>